<template>
    <div class="RadioSelectOption">
        <div class="">
            <div v-if="option.subtitle === undefined">
                <div>{{ option.text }}</div>
            </div>
            <div v-else>
                <div>{{ option.text }}</div>
                <div class="sub-text">{{option.subtitle}}</div>
            </div>
        </div>
        <div>
            <i class="fa-circle brand-primary" :class="[selected ? 'fa-solid' : 'fa-regular']"></i>
        </div>
    </div>
</template>
<script>

export default {
    components: {

    },
    name: "component",
    data() {
        return {

        };
    },
    mounted() {
    },
    beforeDestroy() {

    },
    methods: {
    },
    props: ['option', 'selected', 'updateAnswer'],

};
</script>
<style lang="less">
.RadioSelectOption {
    cursor: pointer;
    font-size: 1.6rem;
    background-color: white;
    border-radius: 12px;
    margin-bottom: 20px;
    padding: 20px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    font-weight: 500;
    .sub-text{
        font-size: 1.4rem;
        font-weight: 400 !important;
    }
    .fa-circle{
        font-size: 2rem;
    }
}
</style>